import styled from 'styled-components'
import { Box, Text as DSText } from '@machobear/design-system'

import { colors, fontSizes, fontWeights } from '@/styles'

const Text = styled.p`
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.regular};
  margin: 0 0 5px;
  transition: all 0.2s ease-in-out;
  white-space: pre-line;
  word-break: break-word;
  width: 100%;
`

interface Props {
  maxChar: number
  description: string
  align?: string
}

const ReadMoreTextBlurred: React.FC<Props> = ({
  maxChar = 100,
  description = ''
}) => {
  const substring = description?.substring(0, maxChar)
  const showReadMore = description?.length > substring?.length

  return (
    <>
      <Text>{substring.replace(/./g, '*')}</Text>
      {showReadMore && (
        <Box style={{ zIndex: 2 }}>
          <DSText tone="disabled">Read more</DSText>
        </Box>
      )}
    </>
  )
}

export default ReadMoreTextBlurred
